import api from 'api/axiosInstance';
import { PreviewFlattenPayload } from 'components/Tree/type';
import { useMutation } from 'react-query';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store';
import {
	setFlatPxAndFacetAffectedPx,
	setFlattenApiFailed,
	setFlattenLoading,
} from 'store/slices/TreeSlice';
import { createApiUrl, getToken } from '../../../util';

type FlattenMutationVars = { coords: number[][], id: string };

export function usePreviewFlatten() {
	const { uuid } = useSelector((state: RootState) => state.roofData.data);
	const dispatch = useDispatch();

	return useMutation({
		mutationKey: `flatten-preview-${uuid}`,
		mutationFn: ({ coords }: FlattenMutationVars) => previewFlatten({ coords, uuid }),
		onSuccess: (data, { id }) => {
			dispatch(setFlatPxAndFacetAffectedPx({
				id,
				flat_px: data?.flat_px ?? null,
				facet_affected_px: data?.facet_affected_pixel_updates ?? null,
				ground_z: data?.ground_z ?? 0,
			}));
		},
		onError: (err: unknown, { id }) => {
			console.error('Failed to update DSM:', err);
			dispatch(setFlattenApiFailed(id));
		},
		onSettled: (_data, _error, { id }) => {
			dispatch(setFlattenLoading({ id, loading: false }));
		},
	});
}

export async function previewFlatten(payload: PreviewFlattenPayload) {
	const token = getToken('Authorization');

	const { data } = await api.post(
		createApiUrl('/designs/dsm-flatten-preview'),
		payload,
		{
			headers: {
				Authorization: `Bearer ${token}`,
			},
		}
	);

	return data;
}
